var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PropertyService } from './../../api/property.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ElementRef, OnDestroy, Injector } from '@angular/core';
import { PropertySearch } from './../../models/index';
import * as Raven from 'raven-js';
import { Subscription } from 'rxjs/Subscription';
import { BaseComponent } from '../base-component';
var AbstractPropertiesSearch = /** @class */ (function (_super) {
    __extends(AbstractPropertiesSearch, _super);
    function AbstractPropertiesSearch(injector, window) {
        var _this = _super.call(this, injector) || this;
        _this.window = window;
        _this.properties = [];
        _this.page = 1;
        _this.apiLoading = false;
        _this.endOfList = false;
        _this.subscription = new Subscription();
        _this.sort = '';
        _this.sortItems = [
            {
                id: 'number',
                text: 'nr. locuință'
            },
            {
                id: 'room_count',
                text: 'nr. camere'
            },
            {
                id: 'bathroom_count',
                text: 'nr. băi'
            },
            {
                id: 'size',
                text: 'suprafață'
            },
            {
                id: 'price',
                text: 'preț'
            }
        ];
        _this.router = injector.get(Router);
        _this.propertyService = injector.get(PropertyService);
        return _this;
    }
    AbstractPropertiesSearch.prototype.getPropertySearch = function () {
        return AbstractPropertiesSearch.propertySearch;
    };
    AbstractPropertiesSearch.prototype.refreshProperties = function () {
        this.page = 1;
        this.properties = [];
        this.apiLoading = false;
        this.endOfList = false;
        Raven.captureBreadcrumb({
            message: 'refreshProperties',
            category: 'properties infinite scroll'
        });
        return this.addProperties();
    };
    AbstractPropertiesSearch.prototype.addProperties = function () {
        var _this = this;
        if (this.apiLoading) {
            return;
        }
        this.apiLoading = true;
        var currentPage = this.page++;
        Raven.captureBreadcrumb({
            message: 'addProperties, page: ' + currentPage,
            category: 'properties infinite scroll'
        });
        this.propertyService.getProperties(AbstractPropertiesSearch.propertySearch, this.sort, currentPage).then(function (properties) {
            _this.apiLoading = false;
            Raven.captureBreadcrumb({
                message: 'addProperties API resonse, page: ' + currentPage,
                category: 'properties infinite scroll'
            });
            if (currentPage === 1) {
                if (_this.properties.length) {
                    Raven.captureMessage('Properties list error: possbile duplication detected', { level: 'warning' });
                }
                _this.properties = properties;
            }
            else {
                _this.properties = _this.properties.concat(properties);
            }
            if (properties.length < 15) {
                _this.endOfList = true;
                return;
            }
        })
            .catch(function () { return _this.apiLoading = false; });
    };
    AbstractPropertiesSearch.prototype.search = function () {
        var _this = this;
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(function () {
            for (var field in AbstractPropertiesSearch.propertySearch) {
                if (AbstractPropertiesSearch.propertySearch[field] === null
                    || AbstractPropertiesSearch.propertySearch[field] === undefined) {
                    delete AbstractPropertiesSearch.propertySearch[field];
                }
            }
            if (_this.window) {
                _this.router.navigate([_this.window.location.pathname], {
                    queryParams: AbstractPropertiesSearch.propertySearch
                });
            }
        }, 200);
    };
    AbstractPropertiesSearch.prototype.onScroll = function () {
        if (this.window) {
            if (!this.endOfList && this.section.nativeElement.getBoundingClientRect().bottom - this.window.innerHeight < 0) {
                this.addProperties();
            }
        }
    };
    AbstractPropertiesSearch.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
    };
    AbstractPropertiesSearch.prototype.resetFilters = function () {
        AbstractPropertiesSearch.propertySearch = new PropertySearch();
        if (!this.form.touched && !this.form.dirty) {
            this.search();
        }
    };
    AbstractPropertiesSearch.propertySearch = new PropertySearch();
    return AbstractPropertiesSearch;
}(BaseComponent));
export { AbstractPropertiesSearch };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/abstract-properties-search.model.ts.pre-build-optimizer.js